import { BFormTextarea } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

/** Bootstrap-vue bridge — replace this file with your own EgBFormTextarea when migrating. */
export const EgBFormTextarea = createEgBootstrapProxy(
  "EgBFormTextarea",
  BFormTextarea
);
